import React, { Component } from 'react';
import { Media } from 'react-bootstrap';

class Course extends Component {
  renderCourseThumbnail() {
    const thumbnailUrl = this.props.thumbnailUrl;
    const courseUrl = this.props.courseUrl;

    const thumbnail = (
      <div className="course-thumbnail">
        {thumbnailUrl ? (
          <img
            className="thumbnail-image"
            src={thumbnailUrl}
            alt="Course thumbnail"
          />
        ) : (
          <img
            className="default-course-thumbnail"
            src="/images/courses/thumbnail-replacement.png"
            alt="Course thumbnail"
          />
        )}
        <img
          className="play-icon"
          src="/images/video-play-icon.svg"
          alt="Play"
        />
      </div>
    );

    if (courseUrl) {
      return (
        <a href={courseUrl} target="_blank" rel="noopener noreferrer">
          {thumbnail}
        </a>
      );
    }

    return thumbnail;
  }

  renderCourseOverview() {
    const { title } = this.props;

    return (
      <Media.Body>
        <Media.Heading>{this.renderCourseTitle(title)}</Media.Heading>
      </Media.Body>
    );
  }

  renderCourseTitle(title) {
    const url = this.props.courseUrl;
    if (url)
      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {title}
        </a>
      );

    return <p>{title}</p>;
  }

  render() {
    return (
      <Media className="work-item">
        <Media.Left className="hidden-sm hidden-xs" align="top">
          <div style={{ marginRight: '16px' }}>
            {this.renderCourseThumbnail()}
          </div>
        </Media.Left>

        {this.renderCourseOverview()}
      </Media>
    );
  }
}

export default Course;
